import React from "react";
import classnames from "classnames";
import RuneTree from "./RuneTree_2";
import StatShardTree from "./StatShardTree_2";

const FullRuneTree = (props) => {
  const { className, primaryStyle, subStyle, activePerks, activeShards, patch, ssr, isMobile } = props;

  return (
    <div className={classnames("rune-trees-container-2", className)}>
      <RuneTree patch={patch} perkStyle={primaryStyle} activePerks={activePerks} primaryPerk ssr={ssr} isMobile={isMobile} />
      <div className="secondary-tree">
        <RuneTree patch={patch} perkStyle={subStyle} activePerks={activePerks} ssr={ssr} isMobile={isMobile} />
        {activeShards && (
          <React.Fragment>
            <div className={classnames("stat-shard-divider", { "_is-mobile": isMobile })} />
            <StatShardTree patch={patch} activeShards={activeShards} ssr={ssr} isMobile={isMobile} />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default FullRuneTree;
